import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import dropsLoader from '@/mixins/components/drops-loader';
import types from '../item-types';

export default Vue.component('dynamic-types-menu', {
  template: require('./template.html'),
  name: 'dynamic-types-menu',
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters(['currentSite']),
    allTypes() {
      let all = Object.keys(types);
      // TODO remove this when stores are ready
      if (this._prod && !this._features.store) {
        all = all.filter(type => type !== 'products');
      }
      return all;
    },
    dynamicTypes() {
      return this.currentSite.addedTypes || [];
    },
  },
  data() {
    return {
      loading: false,
      addData: false,
      options: {},
    };
  },
  created() {
    this.allTypes.forEach((type) => {
      const checked = this.dynamicTypes.includes(type);
      this.$set(this.options, type, checked);
    });
  },
  methods: {
    async saveChanges() {
      this.loading = true;
      try {
        const value = Object.keys(this.options).filter(k => this.options[k]);
        const { addedDynamics } = await this.$lightning([{
          name: 'updateSiteTypes',
          payload: {
            options: this.options,
            siteId: this.currentSite._id,
          },
        }]);
        this.addData = false;
        _.forOwn(addedDynamics, (value, key) => {
          this.$store.dispatch('setGlobalValue', {
            item: this.currentSite.dynamic,
            key,
            value,
          });
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.currentSite,
          key: 'addedTypes',
          value,
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
      } finally {
        this.loading = false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/types-menu/index.js